// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menuitem-loading[data-v-a158284c]{-webkit-animation:menuitem-loading-a158284c 1s infinite!important;animation:menuitem-loading-a158284c 1s infinite!important;opacity:.25}@-webkit-keyframes menuitem-loading-a158284c{0%{opacity:.25}80%{opacity:1}to{opacity:.25}}@keyframes menuitem-loading-a158284c{0%{opacity:.25}80%{opacity:1}to{opacity:.25}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
